export default {
  myLocation: {
    'stopShowingCurrentLocation': 'Haz clic para dejar de mostrar tu ubicación actual',
    'showCurrentLocation': 'Haga clic para mostrar su ubicación actual',
    'yourCurrentLocation': 'Su ubicación actual',
    'continuously': 'Continuamente',
    'onlyOnce': 'Sólo una vez',
    'continuouslyLocation': 'Actualiza su posición cada 2 segundos',
    'onlyOnceLocation': 'Acceda a su posición sólo una vez',
    'myPositionToolTip': 'Activa la localización para mostrar su posición y encontrar lugares cercanos más fácilmente'
  }
}
